/* eslint-disable */
// WARNING: DO NOT REPLACE. This file is not automatically generated by AWS Amplify. It is manually created and should be checked in to source control.
import process from "process";
import { ENVIRONMENT, IS_LOCAL } from "./config.js";
window.process = process;
export const awsConfigDev = {
  aws_project_region: "ap-south-1",
  aws_appsync_graphqlEndpoint:
    "https://zka4o25gozgrpbia4pbe43hwha.appsync-api.ap-south-1.amazonaws.com/graphql",
  aws_appsync_region: "ap-south-1",
  aws_appsync_authenticationType: "AMAZON_COGNITO_USER_POOLS",
  aws_cognito_identity_pool_id:
    "ap-south-1:64ed47b6-53db-4262-b698-9aee30bb2d3f",
  aws_cognito_region: "ap-south-1",
  aws_user_pools_id: "ap-south-1_NoPTQ4KVr",
  aws_user_pools_web_client_id: "7r047chdhfdnabigae3l0teaok",
  oauth: {
    domain:
      "ledgerxdevelopment76736590-76736590-dev.auth.ap-south-1.amazoncognito.com",
    scope: [
      "aws.cognito.signin.user.admin",
      "email",
      "openid",
      "phone",
      "profile",
    ],
    redirectSignIn: IS_LOCAL ? "http://localhost:3000/" : "https://dev.ledgerx365.com/",
    redirectSignOut: IS_LOCAL ? "http://localhost:3000/logout" : "https://dev.ledgerx365.com/logout",
    responseType: "code",
  },
  federationTarget: "COGNITO_USER_POOLS",
  aws_cognito_username_attributes: ["EMAIL"],
  aws_cognito_social_providers: ["GOOGLE"],
  aws_cognito_signup_attributes: ["EMAIL"],
  aws_cognito_mfa_configuration: "OFF",
  aws_cognito_mfa_types: ["SMS"],
  aws_cognito_password_protection_settings: {
    passwordPolicyMinLength: 8,
    passwordPolicyCharacters: [],
  },
  aws_cognito_verification_mechanisms: ["EMAIL"],
};

export const awsConfigQA = {
  aws_project_region: "ap-south-1",
  aws_cognito_identity_pool_id:
    "ap-south-1:ef733425-05c7-4e3d-b38f-09ee2693490d",
  aws_cognito_region: "ap-south-1",
  aws_user_pools_id: "ap-south-1_cFx8uT2vn",
  aws_user_pools_web_client_id: "ibvibpn6sa3iprg5il2lhsl1g",
  oauth: {
    domain: "ledxnews2f5bf499-2f5bf499-prod.auth.ap-south-1.amazoncognito.com",
    scope: [
      "aws.cognito.signin.user.admin",
      "email",
      "openid",
      "phone",
      "profile",
    ],
    redirectSignIn: "https://qa.ledgerx365.com/",
    redirectSignOut: "https://qa.ledgerx365.com/logout",
    responseType: "code",
  },
  federationTarget: "COGNITO_USER_POOLS",
  aws_cognito_username_attributes: ["EMAIL"],
  aws_cognito_social_providers: ["GOOGLE"],
  aws_cognito_signup_attributes: ["EMAIL"],
  aws_cognito_mfa_configuration: "OFF",
  aws_cognito_mfa_types: [],
  aws_cognito_password_protection_settings: {
    passwordPolicyMinLength: 8,
    passwordPolicyCharacters: [],
  },
  aws_cognito_verification_mechanisms: ["EMAIL"],
  aws_appsync_graphqlEndpoint:
    "https://wnfnn53kdfaj7l45nakwtnh2ee.appsync-api.ap-south-1.amazonaws.com/graphql",
  aws_appsync_region: "ap-south-1",
  aws_appsync_authenticationType: "AMAZON_COGNITO_USER_POOLS",
};

export const awsConfigBeta = {
  aws_project_region: "ap-south-1",
  aws_appsync_graphqlEndpoint:
    "https://6zbvufil7fdw5hs37mqd7eiue4.appsync-api.ap-south-1.amazonaws.com/graphql",
  aws_appsync_region: "ap-south-1",
  aws_appsync_authenticationType: "AMAZON_COGNITO_USER_POOLS",
  aws_cognito_identity_pool_id:
    "ap-south-1:ef733425-05c7-4e3d-b38f-09ee2693490d",
  aws_cognito_region: "ap-south-1",
  aws_user_pools_id: "ap-south-1_cFx8uT2vn",
  aws_user_pools_web_client_id: "ibvibpn6sa3iprg5il2lhsl1g",
  oauth: {
    domain: "ledxnews2f5bf499-2f5bf499-prod.auth.ap-south-1.amazoncognito.com",
    scope: [
      "aws.cognito.signin.user.admin",
      "email",
      "openid",
      "phone",
      "profile",
    ],
    redirectSignIn: "https://beta.ledgerx365.com/",
    redirectSignOut: "https://beta.ledgerx365.com/logout",
    responseType: "code",
  },
  federationTarget: "COGNITO_USER_POOLS",
  aws_cognito_username_attributes: ["EMAIL"],
  aws_cognito_social_providers: ["GOOGLE"],
  aws_cognito_signup_attributes: ["EMAIL"],
  aws_cognito_mfa_configuration: "OFF",
  aws_cognito_mfa_types: [],
  aws_cognito_password_protection_settings: {
    passwordPolicyMinLength: 8,
    passwordPolicyCharacters: [],
  },
  aws_cognito_verification_mechanisms: ["EMAIL"],
};

export const awsConfigSecurity = {
  aws_project_region: "ap-south-1",
  aws_cognito_identity_pool_id:
    "ap-south-1:b2a0b6f8-ec94-4b50-83ee-c5f3f4be62d6",
  aws_cognito_region: "ap-south-1",
  aws_user_pools_id: "ap-south-1_clIlU4fGq",
  aws_user_pools_web_client_id: "7o4onuj86hphkh0h4lu08otpo8",
  oauth: {
    domain:
      "ledxnews18766cd3-18766cd3-quality.auth.ap-south-1.amazoncognito.com",
    scope: [
      "phone",
      "email",
      "openid",
      "profile",
      "aws.cognito.signin.user.admin",
    ],
    redirectSignIn: "https://sit.ledgerx365.com/",
    redirectSignOut: "https://sit.ledgerx365.com/logout",
    responseType: "code",
  },
  federationTarget: "COGNITO_USER_POOLS",
  aws_cognito_username_attributes: ["EMAIL"],
  aws_cognito_social_providers: ["GOOGLE"],
  aws_cognito_signup_attributes: ["EMAIL"],
  aws_cognito_mfa_configuration: "OFF",
  aws_cognito_mfa_types: ["SMS"],
  aws_cognito_password_protection_settings: {
    passwordPolicyMinLength: 8,
    passwordPolicyCharacters: [],
  },
  aws_cognito_verification_mechanisms: ["EMAIL"],
  aws_appsync_graphqlEndpoint:
    "https://at2lammsprdvrpeige7rzozl3i.appsync-api.ap-south-1.amazonaws.com/graphql",
  aws_appsync_region: "ap-south-1",
  aws_appsync_authenticationType: "AMAZON_COGNITO_USER_POOLS",
};

export const awsConfigProd = {
  aws_project_region: "ap-south-1",
  aws_cognito_identity_pool_id:
    "ap-south-1:ef733425-05c7-4e3d-b38f-09ee2693490d",
  aws_cognito_region: "ap-south-1",
  aws_user_pools_id: "ap-south-1_cFx8uT2vn",
  aws_user_pools_web_client_id: "ibvibpn6sa3iprg5il2lhsl1g",
  oauth: {
    domain: "ledxnews2f5bf499-2f5bf499-prod.auth.ap-south-1.amazoncognito.com",
    scope: [
      "phone",
      "email",
      "openid",
      "profile",
      "aws.cognito.signin.user.admin",
    ],
    redirectSignIn: "https://app.ledgerx.biz/",
    redirectSignOut: "https://app.ledgerx.biz/logout",
    responseType: "code",
  },
  federationTarget: "COGNITO_USER_POOLS",
  aws_cognito_username_attributes: ["EMAIL"],
  aws_cognito_social_providers: ["GOOGLE"],
  aws_cognito_signup_attributes: ["EMAIL"],
  aws_cognito_mfa_configuration: "OFF",
  aws_cognito_mfa_types: ["SMS"],
  aws_cognito_password_protection_settings: {
    passwordPolicyMinLength: 8,
    passwordPolicyCharacters: [],
  },
  aws_cognito_verification_mechanisms: ["EMAIL"],
  aws_appsync_graphqlEndpoint:
    "https://7gp42kr5bjgozbvl4k35etpkni.appsync-api.ap-south-1.amazonaws.com/graphql",
  aws_appsync_region: "ap-south-1",
  aws_appsync_authenticationType: "AMAZON_COGNITO_USER_POOLS",
};

export const awsConfigProd_dep = {
  aws_project_region: "ap-south-1",
  aws_cognito_identity_pool_id:
    "ap-south-1:dfb093ce-59f0-4b5d-9497-53e837edd8b7",
  aws_cognito_region: "ap-south-1",
  aws_user_pools_id: "ap-south-1_qrfo5yvFa",
  aws_user_pools_web_client_id: "7d1fsb9s9ickenvllr5rcfuc7f",
  oauth: {
    domain:
      "ledgerxprode10ace1e-e10ace1e-dev.auth.ap-south-1.amazoncognito.com",
    scope: [
      "phone",
      "email",
      "openid",
      "profile",
      "aws.cognito.signin.user.admin",
    ],
    redirectSignIn: "https://app.ledgerx.biz/",
    redirectSignOut: "https://app.ledgerx.biz/logout",
    responseType: "code",
  },
  federationTarget: "COGNITO_USER_POOLS",
  aws_cognito_username_attributes: ["EMAIL"],
  aws_cognito_social_providers: ["GOOGLE"],
  aws_cognito_signup_attributes: ["EMAIL"],
  aws_cognito_mfa_configuration: "OFF",
  aws_cognito_mfa_types: ["SMS"],
  aws_cognito_password_protection_settings: {
    passwordPolicyMinLength: 8,
    passwordPolicyCharacters: [],
  },
  aws_cognito_verification_mechanisms: ["EMAIL"],
  aws_appsync_graphqlEndpoint:
    "https://ohutfeqopfay3iejyorfph4xpy.appsync-api.ap-south-1.amazonaws.com/graphql",
  aws_appsync_region: "ap-south-1",
  aws_appsync_authenticationType: "AMAZON_COGNITO_USER_POOLS",
  aws_appsync_apiKey: "da2-bwjpbjxtuvgo3hkd5xzo3uzlgi",
};

const config =
  {
    development: awsConfigDev,
    QA: awsConfigQA,
    beta: awsConfigBeta,
    security: awsConfigSecurity,
    production: awsConfigProd,
    production_dep: awsConfigProd_dep,
  }[ENVIRONMENT] || awsConfigDev;
console.log({ ENVIRONMENT });
export default config;
